import axios from 'axios';

const list = (data) => axios.get('/logist/distribut/list', data);
const save = (data) => axios.post('/logist/distribut/save', data);
const del = (data) => axios.post('/logist/distribut/delete', data); //delete

export default {
  list,
  save,
  del,
}


